import { Navigate } from 'react-router';
import { CircularProgress, Box } from '@mui/material';
import { useAuth } from './useAuth';
import type { Role } from '@altyor-kronos/shared-types';

/**
 * Route guard that allows access to any user holding at least one of
 * the listed roles. Users who pass none of the roles are redirected to
 * /projects (same behaviour as RequireAdmin).
 */
export function RequireRole({
  allowedRoles,
  children,
}: {
  allowedRoles: Role[];
  children: React.ReactNode;
}) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  const hasAccess = user?.roles.some((r) => allowedRoles.includes(r)) ?? false;
  if (!hasAccess) {
    return <Navigate to="/projects" replace />;
  }

  return <>{children}</>;
}
